import { render, staticRenderFns } from "./interfaceSub.vue?vue&type=template&id=2779d203"
import script from "./interfaceSub.vue?vue&type=script&lang=js"
export * from "./interfaceSub.vue?vue&type=script&lang=js"
import style0 from "./interfaceSub.vue?vue&type=style&index=0&id=2779d203&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports